import * as firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyDiXHCzzj4ObLmBfh6Srq9kCCSpzwiZWEY",
  authDomain: "udeaflix.firebaseapp.com",
  databaseURL: "https://udeaflix.firebaseio.com",
  projectId: "udeaflix",
  storageBucket: "udeaflix.appspot.com",
  messagingSenderId: "817308173771",
  appId: "1:817308173771:web:8d4a8224442ea9622e624e",
  measurementId: "G-RV0HQB11HF"
};

const fire = firebase.initializeApp(firebaseConfig);

export default fire;
